import * as React from "react";
import { Grid, Typography } from "components/controls/widget";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import DivBox from "common/components/controls/DivBox";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import PageContent from "common/web/PageContent";
import { hasFlag } from "components/state/types";
import VekKtg from "common/utils/VekKtg";
import { formatDate } from "common/utils/FmtDate";
import { useMemberValidation, isMemberValidationState } from "../../../../../member-validation/store";
import { useUIContext } from "../../../../../context/store";
import { MemberValidationState } from "../../../../../member-validation/entity";

import { useMemberDetail } from "../store";
import { EmailView } from "./email/view";
import { PhoneView } from "./phone/view";

const Adresa = () => {
    const [{ entity }] = useMemberDetail();

    const adresa = entity.bydliste;

    const getAdr = (a: string) => {
        return a && <Grid item>{a.trim()}</Grid>;
    }

    const getAdr2 = (p: string, a: string) => {
        const psc = p?.trim();
        const posta = a?.trim();
        return (psc || posta) ? <Grid item>{psc.substr(0, 3) + ' ' + psc.substr(3, 2) + ' ' + posta}</Grid> : null;
    }

    return <Grid container direction="column" spacing={8} justify="space-between">
        {getAdr(adresa?.ulice)}
        {getAdr(adresa?.obec)}
        {getAdr2(adresa?.psc, adresa?.posta)}
    </Grid>
}


const NazevDivize = () => {
    const [{ entity }] = useMemberDetail();
    const registrovanVDivizi = entity.divize ? entity.divize.nazev : null;
    const spadaDoDivize = entity.klub ? entity.klub.nazevDivize : registrovanVDivizi;

    return <div>
        {spadaDoDivize ? spadaDoDivize : 'neurčeno'}
    </div>
}


const Klub = () => {
    const [{ entity }] = useMemberDetail();

    const klub = entity.klub;

    return <div>
        {klub
            ? <Grid container direction="column" spacing={8} justify="space-between">
                <Grid item>{klub.nazev}</Grid>
                <Grid item><DivBox noPadding weight="lighter">{'Datum vstupu do klubu: ' + formatDate(klub.datVstupu)}</DivBox></Grid>
            </Grid>
            : 'není'}
    </div>
}


const memberIdentificationStyles = (theme: Theme) => createStyles({
    content: {
        padding: theme.spacing.unit,
    },
});

const MemberIdentification = withStyles(memberIdentificationStyles)(
    () => {
        const [{ entity, memberCardUrl }] = useMemberDetail();
        return <Grid container direction="row" spacing={32} justify="flex-start" alignItems="center">
            <Grid item>{entity.idtClena}</Grid>
            {entity.showMemberCardLink ? <Grid item><a href={memberCardUrl}>{'Evidenční kartička'}</a></Grid> : null}
        </Grid>;
    });

const View = () => {

    const [{ entity, isSecretary, initialized }] = useMemberDetail();
    const [memberValidationState, { getValidationState, invalidateValidationCache }] = useMemberValidation();
    const [contextState, { loadMember }] = useUIContext();
    const validationState = memberValidationState.entity.state;


    React.useEffect(() => {
        if (initialized && entity) {
            loadMember(entity.idtClena);
        }
    }, [initialized]);


    React.useEffect(() => {
        if (contextState.memberLoaded && entity && contextState.data.member) {
            invalidateValidationCache();
        }

    }, [contextState.memberLoaded]);

    React.useEffect(() => {
        getValidationState(entity?.idtClena);
    }, [memberValidationState.dataValid, entity?.idtClena]);

    const userAndMemberIdtEquals = contextState.data.member.userMemberIdt === entity?.idtClena;
    const showSensitiveData = isSecretary || (entity?.verified === true && userAndMemberIdtEquals);
    const showBydliste = showSensitiveData;
    const showEmail = showSensitiveData
        || (hasFlag(validationState, MemberValidationState.EmailValidAndPending) && userAndMemberIdtEquals);
    const showTelefon = showSensitiveData
        || (hasFlag(validationState, MemberValidationState.PhoneValidAndPending) && userAndMemberIdtEquals);
    const showDatNaroz = showSensitiveData;

    const items: DetailGridItem[] = entity ? [
        { label: 'Identifikační číslo (IDT)', content: <MemberIdentification /> },
        { label: 'Příjmení', content: entity.prijmeni },
        { label: 'Jméno', content: entity.jmeno },
        { label: 'Titul', content: entity.titul },
        { label: 'Datum narození', content: formatDate(entity.datNaroz), show: showDatNaroz },
        { label: 'Věková kategorie', content: VekKtg.getVek(entity.vekKtg, entity.vekKtg2) },
        { divider: true, show: showBydliste || showEmail || showTelefon },
        { label: 'Bydliště', content: <Adresa />, show: showBydliste },
        { label: 'Email', content: <EmailView />, show: showEmail },
        { label: 'Telefon', content: <PhoneView />, show: showTelefon },
        { divider: true },
        //{ label: 'Registrován(a) v divizi', content: <NazevDivizeComponent nazev={registrovanVDivizi} /> },
        { label: 'Registrován(a) v klubu', content: <Klub /> },
        { label: 'Spadá do divize', content: <NazevDivize /> },
    ] : [];

    return <PageContent titles={['Osobní údaje']}>
        <DetailGrid items={items} />
    </PageContent>

}

//const DecoratedView = withRouter(withStyles(styles)(View));

export {
    View as OsobniUdaje
}